<template>
  <svg
    class="mypage-ticket-close-icon-parts"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M16.5858 6H19.4143L13.4142 12.0001L19.4141 18L16.5857 18L12 13.4143L7.41427 18L4.58585 18L10.5858 12.0001L4.58569 6H7.41412L12 10.5859L16.5858 6Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MypageTicketCloseIconParts',
})
</script>

<style scoped lang="scss">
.mypage-ticket-close-icon-parts {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
